import React, { useState } from 'react';
import styled from 'styled-components';
import { MailOutlined } from '@ant-design/icons';
import { Form, Input, Button, Space, Modal } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';

const { Item } = Form;

const StyledMailOutlined = styled(MailOutlined)`
  font-size: 18px;
  color: ${(props) => props.theme.iconColor};
`;

const EmailInput = styled(Input)`
  height: 32px;
  border-radius: 6px;
  .ant-input {
    font-size: 15px;
    border: none;
  }
  .ant-input:not(:first-child) {
    padding-left: 12px !important;
  }
`;

interface Props {
  handleSubmit: (data: any) => void;
}

export interface FormValues {
  email: string;
}

const ForgotPasswordForm: React.FC<Props> = ({ handleSubmit }) => {
  const intl = useIntl();
  const [form] = Form.useForm<FormValues>();
  const [isEmailUpperCase, setIsEmailUpperCase] = useState(false);

  const handleModalCancel = () => {
    setIsEmailUpperCase(false);
  };

  const handleModalConfirm = () => {
    handleSubmit(form.getFieldsValue());
    form.resetFields();
    setIsEmailUpperCase(false);
  };

  return (
    <>
      <Form
        form={form}
        requiredMark={false}
        layout="vertical"
        css="width: 100%;"
        onFinish={(values) => {
          handleSubmit(values);
          form.resetFields();
        }}
      >
        <Space
          orientation="vertical"
          css="width: 100%; row-gap: 0px;"
          size="middle"
        >
          <Item
            name="email"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  defaultMessage: 'This field is required',
                }),
              },
              {
                type: 'email',
                message: intl.formatMessage({
                  defaultMessage: 'A valid email is required',
                }),
              },
            ]}
          >
            <EmailInput
              type="email"
              size="large"
              prefix={<StyledMailOutlined />}
              placeholder={intl.formatMessage({ defaultMessage: 'Email' })}
              onChange={() => {
                const { email } = form.getFieldsValue();
                if (email && email !== email.toLowerCase()) {
                  setIsEmailUpperCase(true);
                }
              }}
            />
          </Item>
          <Item css="margin: 0;">
            <Button type="primary" size="large" htmlType="submit" block>
              <FormattedMessage defaultMessage="Request new password" />
            </Button>
          </Item>
        </Space>
      </Form>
      <Modal
        open={isEmailUpperCase}
        onCancel={handleModalCancel}
        onOk={handleModalConfirm}
        okText={intl.formatMessage({ defaultMessage: 'Send' })}
        title={intl.formatMessage({
          defaultMessage: 'Is your Email address correct?',
        })}
      >
        <p>
          {intl.formatMessage({
            defaultMessage:
              'We detected uppercase letters. If the email address does not match our entry, your reset-link could not arrive. Do you want to proceed anyway?',
          })}
        </p>
      </Modal>
    </>
  );
};

export default ForgotPasswordForm;
